const apiUrl = process.env.REACT_APP_API_URL;

export const PutComandaGeneradaRevisada = async (
    page: string,
    id: number,
    revisada: number,
    idUsuLog: string
): Promise<boolean> => {
    try {
        const response = await fetch(
            `${apiUrl}:8072/comandesgenerades/${id}/revisada/${idUsuLog}?revisada=${revisada}`,
            {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'pantalla': page
                }
            }
        );
        return response.ok;
    } catch (error) {
        console.log('Error PutComandaGeneradaRevisada:', error);
        return false;
    }
};
